export const SET_PHOTO = "SET_PHOTO";
export const SET_FILENAME = "SET_FILENAME";
export const SET_FILTER = "SET_FILTER";
export const RESET_FILTERS = "RESET_FILTERS";
export const INIT_LIGHTBOX= "INIT_LIGHTBOX";
export const UPDATE_RELEASE_NOTES= "UPDATE_RELEASE_NOTES";
